import React from 'react'

export default function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25" {...props}>
      <g>
        <path
          fill="#21201F"
          fillRule="evenodd"
          d="M12 4a1 1 0 0 0-1 1v7H4a1 1 0 0 0 0 2h7v7a1 1 0 0 0 2 0v-7h7a1 1 0 0 0 0-2h-7V5a1 1 0 0 0-1-1"
          clipRule="evenodd"
        ></path>
      </g>
    </svg>
  )
}
